import { render, staticRenderFns } from "./EditHeatmapOrGridData.vue?vue&type=template&id=0e0c107c&"
import script from "./EditHeatmapOrGridData.vue?vue&type=script&lang=js&"
export * from "./EditHeatmapOrGridData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../HistomicsUI/histomicsui/web_client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/HistomicsUI/histomicsui/web_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e0c107c')) {
      api.createRecord('0e0c107c', component.options)
    } else {
      api.reload('0e0c107c', component.options)
    }
    module.hot.accept("./EditHeatmapOrGridData.vue?vue&type=template&id=0e0c107c&", function () {
      api.rerender('0e0c107c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@girder/histomicsui/vue/components/EditHeatmapOrGridData.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./~/@girder/histomicsui/vue/components/EditHeatmapOrGridData.vue
// module id = 61
// module chunks = 0